<template>
  <div>
    <div class="carousel-inner"
      :total="slides.length" 
      :current-index="currentSlide"
      draggable=true
      @dragstart="drag($event)"
      @dragend="drag1($event)">
      <carousel-indicators 
      :total="slides.length" 
      :current-index="currentSlide"
      @switch="switchSlide($event)"
      />
      <carousel-item 
      v-for="(slide, index) in slides" 
      :slide="slide" 
      :key="`item-${index}`"
      :current-slide="currentSlide"
      :index="index"
      :title="texts[index].title"
      :text="texts[index].text"
      :texten="texts[index].texten"
      />
      <p class="line-top"></p>
      <CarouselControls @prev="prev" @next="next"/>
    </div>
  </div>
</template>

<script>
import CarouselItem from './CarouselItem';
import CarouselControls from './CarouselControls';
import CarouselIndicators from './CarouselIndicators';
export default {
  props: ['slides'],
  components: {CarouselItem, CarouselControls, CarouselIndicators},
  data: () => ({
    currentSlide:0,
    slideInterval: null,
    dragD:0,
    texts: [
            {
                title: "CHRIS HOTEL",
                text: "ΓΙΑ ΜΙΑ ΑΞΕΧΑΣΤΗ ΕΜΠΕΙΡΙΑ",
                texten: "FOR AN UNFORGETTABLE EXPERIENCE" 
            },
            {
                title: "CHRIS HOTEL", 
                text: "ΔΙΑΜΟΝΗ ΑΝΑΜΕΣΑ ΣΤΑ ΠΕΥΚΑ",
                texten: "ACCOMMODATION AMONG THE PINES"
            },
    ],
  }),
  methods: {
    setCurrentSlide (index) {
      this.currentSlide = index;
    },
    next(step = 1){
      const index = this.currentSlide < this.slides.length -1 ? this.currentSlide + step : 0;
      this.setCurrentSlide(index); 
    },
    prev(step = -1){
      const index = this.currentSlide > 0 ? this.currentSlide + step : this.slides.length -1;
      this.setCurrentSlide(index); 
    },
    switchSlide(index){
      console.log(index);
      const step = index - this.currentSlide;
      if(step > 0){
        this.next(step);
      }
      else{
        this.prev(step);
      }
    },
    drag(event){
      this.dragD=event.clientX;
    },
    drag1(event){  
      const dif = event.clientX - this.dragD;
      this.dragD=dif;
      if(this.dragD >= 0){
        const index = this.currentSlide > 0 ? this.currentSlide - 1 : this.slides.length -1;
        this.setCurrentSlide(index);
      }
      else{
        const index = this.currentSlide < this.slides.length -1 ? this.currentSlide + 1 : 0;
        this.setCurrentSlide(index);
      }
    },
    
  },
  mounted () {
    this.slideInterval = setInterval(() => {
      this.next(); 
    }, 10000)
  },
  beforeUnmount () {
    clearInterval(this.slideInterval);
  }
}
</script>

<style>
  .carousel {
    display: flex;
    justify-content: center;
		height:600px;
    cursor: pointer !important;
  }

  .carousel-inner{
    position: relative !important;
    width:100% !important;
    height:600px !important;
    overflow: hidden !important;
    cursor: pointer !important;
  }
  #app .carousel-inner, #app .carousel{
    height:550px !important;
  }

</style>